module.exports = __webpack_public_path__ + "static/media/1014887.5ed1d0e5.jpg";